import { render } from "./AddItem.vue?vue&type=template&id=f16d7d16"
import script from "./AddItem.vue?vue&type=script&lang=js"
export * from "./AddItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__